import type { LegacySubscription } from '../../types';

export function isTrial(subscription: LegacySubscription): boolean {
  return subscription.isTrial ?? false;
}
